import { DialogService, GridAction } from '@eforall/dashboard';
import { PersonEntrepreneurship } from '@interfaces';

export function getActions(dialog: DialogService) {

	const actions: GridAction<PersonEntrepreneurship>[] = [];

	return actions;
}